var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.399941 8.78C0.649758 9.02834 0.987694 9.16772 1.33994 9.16772C1.69219 9.16772 2.03012 9.02834 2.27994 8.78L7.06661 4.06L11.7866 8.78C12.0364 9.02834 12.3744 9.16772 12.7266 9.16772C13.0789 9.16772 13.4168 9.02834 13.6666 8.78C13.7916 8.65605 13.8908 8.50858 13.9585 8.3461C14.0262 8.18362 14.061 8.00935 14.061 7.83333C14.061 7.65732 14.0262 7.48304 13.9585 7.32057C13.8908 7.15809 13.7916 7.01062 13.6666 6.88667L8.01327 1.23333C7.88932 1.10836 7.74186 1.00917 7.57938 0.94148C7.4169 0.873788 7.24262 0.838937 7.06661 0.838937C6.89059 0.838937 6.71632 0.873788 6.55384 0.94148C6.39136 1.00917 6.24389 1.10836 6.11994 1.23333L0.399941 6.88667C0.27497 7.01062 0.175778 7.15809 0.108087 7.32057C0.0403948 7.48304 0.00554276 7.65732 0.00554276 7.83333C0.00554276 8.00935 0.0403948 8.18362 0.108087 8.3461C0.175778 8.50858 0.27497 8.65605 0.399941 8.78Z",
    fill: "#0F82ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleUp);
export default __webpack_public_path__ + "static/media/AngleUp.05f32bd91710d0f07292e44822fe4826.svg";
export { ForwardRef as ReactComponent };